export default "__VITE_ASSET__DFR3D7Wt__"